import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from '@/config/i18nFn'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Navigation from 'vue-navigation'

import Vant from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import './util/rem'
import './util/common'

// require styles
import 'swiper/dist/css/swiper.css'
import '@/config/api'
import '@/config/axios'

const Base64 = require('js-base64').Base64;
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(preview)

Vue.use(Navigation, {
  router
})

Vue.config.productionTip = false
Vue.prototype.$watermark = '?x-oss-process=image/watermark,image_dXBsb2FkL2Jyb2tlL3dhdGVybWFyay9FY29Qcm9wLnBuZz94LW9zcy1wcm9jZXNzPWltYWdlL3Jlc2l6ZSxwXzMw,t_30,g_se,x_10,y_0,image/interlace,1'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js